import React, {FC, ReactNode} from 'react';
import {Pressable, StyleProp, TextStyle, View} from 'react-native';
import {style} from './Step.style';
import {StepIndicator} from './stepIndicator/StepIndicator';
import {StepVariant} from './StepVariant';

enum StepPosition {
  FIRST = 'FIRST',
  DEFAULT = 'DEFAULT',
  LAST = 'LAST',
}

type StepProps = {
  readonly children: (styleProps: StyleProp<TextStyle>) => ReactNode;
  readonly variant: StepVariant;
  readonly position?: StepPosition;
  readonly onPress?: () => void;
};
const Step: FC<StepProps> = ({children, variant, position = StepPosition.DEFAULT, onPress}) => (
  <Pressable style={style.step} onPress={onPress} testID="step" disabled={variant === StepVariant.DISABLED}>
    <StepIndicator variant={variant} />
    <View style={style.stepContent}>{children(style[`stepText_${variant}`])}</View>
    {position !== StepPosition.FIRST && <View style={[style.track, style.trackTop, style[`trackTop_${variant}`]]} />}
    {position !== StepPosition.LAST && (
      <View style={[style.track, style.trackBottom, style[`trackBottom_${variant}`]]} />
    )}
  </Pressable>
);

export {StepPosition, Step};
